/** A cap of 0 (or missing) means no maximum. Strictly-greater matches v1's behaviour. */
export function isOverCap(reward: number, max: number | undefined): boolean {
  return !!max && max > 0 && reward > max
}
